import React, { memo } from "react";

const CompactTarget = memo(({ target, achieved }) => {
  const percentage = target > 0 ? Math.min((achieved / target) * 100, 100) : 0;
  const isAchieved = percentage >= 100;
  const formatCurrency = (amount) => `₹ ${amount.toLocaleString('en-IN')}`;
  
  return (
    <div className="flex items-center space-x-4 bg-white rounded-md px-3 py-2 border shadow-sm">
      <div className="flex items-center space-x-2 text-sm">
        <span className="text-gray-600">Target:</span>
        <span className="font-semibold text-blue-600">{formatCurrency(target)}</span>
      </div>
      
      <div className="flex items-center space-x-2 text-sm">
        <span className="text-gray-600">Achieved:</span>
        <span className="font-semibold text-green-600">{formatCurrency(achieved)}</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <div className="w-24 bg-gray-200 rounded-full h-2">
          <div 
            className={`h-2 rounded-full transition-all duration-300 ${
              isAchieved ? 'bg-green-500' : 'bg-blue-500'
            }`}
            style={{ width: `${percentage}%` }}
          />
        </div>
        {isAchieved && <span className="text-green-600 text-sm">✓</span>}
      </div>
    </div>
  );
});

export default CompactTarget;